export enum StateModalResult {
  'SUCCESS' = 'success',
  'ERROR' = 'error',
  'WARNING' = 'warning',
}
